<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    :editIcon="editIcon"
    :readOnly="readOnly"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :isTextButton="isTextButton"
    :textButton="textButton"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        id="printableELement"
        :editOnly="editOnly"
        :readOnly="readOnly"
        @installment-update="loadServerEntry(entry.id)"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null,
      partialReadOnly: false
    };
  },
  props: {
    entry: Object,
    // editTitle: {
    //   type: String,
    //   default: "Edição de Parcela a Receber"
    // },
    // readTitle: {
    //   type: String,
    //   default: "Visualização de Parcela a Receber"
    // },
    editIcon: {
      type: String,
      default: "mdi-pencil"
    },
    editOnly: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    // partialReadOnly: {
    //   type: Boolean,
    //   default: false
    // },
    isTextButton: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit,
    BasePrint: BasePrint
  },
  created() {
  },
  methods: {
    loadServerEntry: function(id) {
      // console.log(id);
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_CASH_INFLOW_INSTALLMENT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.cashInflowInstallment;
          this.extraData = response.data;
          // if (this.editableEntry.canBeDeleted === false) {
          //   this.partialReadOnly = true;
          // }
          // console.log("cashInflowInstallment edit", this.editableEntry);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(installment) {
      // console.log("installment", installment, installment.validations, this.deepFilterEntryWithAllowedFieldsForMutation(installment, installment.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_UNPAID_INSTALLMENT_MUTATION,
          variables: {
            input: {
              id: installment.id,
              dueDate: installment.dueDate,
              observation: installment.observation,
              paymentMethodId: installment.paymentMethod.id,
              bankAccountId: installment.bankAccountId,
            }
          }
        })
        .then(response => {
          var errors = response.data.updateUnpaidInstallment.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
      this.$emit("entry-canceled");
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_CASH_INFLOW_INSTALLMENT_QUERY = gql `
  query ($id: ID!) {
  accountContext {
    cashInflowInstallment(id: $id){
      id
      code
      payment {
        cashFlow {
          chart {
            name
          }
          customer {
            name
          }
        }
      }
      dueDate
      paymentDate
      paymentMethod {
        id
        name
      }
      bankAccountId
      bankAccount {
        id
        name
        nameWithBank
        currentBalance
        accountNumber
        agencyNumber
        bankAccountType {
          id
          name
        }
        bank {
          id
          name
          nameWithCode
        }
      }
      originalValue
      value
      interest
      penalty
      discount
      paidAmount
      totalPaidAmount
      isFullyPaid
      isPartiallyPaid
      observation
      parentObservation
      additionalPaymentsAttributes {
        id
        code
        bankAccountId
        paymentMethodId
        value
        initialDate
        installmentsIntervalId
        installmentsInterval {
          id
          description
          intervalInDays
        }
        paymentConditionId
        paymentCondition {
          id
          description
          numberOfInstallments
        }
        paymentMethod {
          id
          name
        }
        bankAccount {
          id
          name
        }
        installmentsAttributes {
          id
          value
          originalValue
          customCode
          dueDate
          code
          status
          statusKey
          statusColor
          paidAmount
          totalPaidAmount
          paymentDate
          bankAccount {
            id
            name
          }
        }
      }
      validations
      fullPaymentValidations
      partialPaymentValidations
    }
    allBankAccountsForInstallment(installmentId: $id) {
      id
      name
      nameWithBank
      currentBalance
      accountNumber
      agencyNumber
      bankAccountType {
        id
        name
      }
      bank {
        id
        name
        nameWithCode
      }
    }
  }
  globalContext{
    allGlobalPaymentMethods{
      id
      name
    }
  }
}
`;

const UPDATE_UNPAID_INSTALLMENT_MUTATION = gql `
  mutation($input: UpdateInstallmentWhileUnpaidInputObject!) {
    updateUnpaidInstallment(input: $input) {
      installment {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
